<template>
  <div class="form-group">
    <input
      :value="value"
      :type="type"
      :class="['form-control', { 'is-invalid': errMsg !== '' }]"
      :placeholder="placeholder"
      :maxLength="maxLength"
      @change="$emit('change', $event.target.value)"
    />
    <div class="invalid-feedback" v-show="errMsg !== ''">
      {{ errMsg }}
    </div>
  </div>
</template>

<script>
export default {
  name: "MyInput",
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: String,
    type: {
      Object: String,
      default: "text"
    },
    placeholder: {
      Object: String,
      default: ""
    },
    maxLength: {
      Object: String,
      default: ""
    },
    errMsg: {
      Object: String,
      default: ""
    }
  }
};
</script>
